module.exports = __webpack_public_path__ + "static/media/delete.f055e73d.svg";